export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14681.a4325110.jpg";